<template>
  <div class="checkout-page">
    <div class="order-summary">
      <table>
        <thead>
          <tr>
            <th>PRODUCT</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ course.name }}</td>
            <td>{{ course.price }} Azadi Coin (AC)</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="container" v-if="step === 1">
       <h2>Order Checkout</h2>
      <Login @formsubmit="step = 2" :showWelcomeBanner="false" />
      <p class="note">
       <!-- **note for the development: show this page when the user is not logged in or registered -->
      </p>
    </div>
    <!-- <div class="container" v-else-if="step === 2">
      <CheckoutForm
        :prefilledData="userData"
        @formSubmitted="handleFormSubmission"
      />
      <p class="note">
        **note for the development: If the user is already registered/logged in,
        please show the information of first name, last name, Email address, and
        country
      </p>
    </div> -->
    <div class="container" v-if="step === 2">
       <h2>Order Checkout</h2>
       <CustomerInfo  />
      <PaymentDetails @formsubmit="$router.push('/checkout-success')" />
      <p class="note">
       <!-- **note for the development: I would like to be able to change the “Solana fee address” -->
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import CheckoutForm from "./CheckoutForm.vue";
import CustomerInfo from "./CustomerInfo.vue";
import Login from "./Login.vue";
import PaymentDetails from "./PaymentDetails.vue";
export default {
  components: {
    // CheckoutForm,
    CustomerInfo,
    Login,
    PaymentDetails
  },
  data() {
    return {
      step: 1,
      course: {},
      userData: {
        firstName: "", // Example data for logged-in user
        lastName: "",
        email: "",
        country: "",
        zipcode: '',
        phone: "",
        city: "",
        addressLine1: ""
      },
    };
  },
  computed: {
    isLoggedIn() { 
      return this.$store.getters.isAuthenticated
    },
    user() { 
      return this.$store.getters.StateUser.data
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.step = 2;
    }
    console.log(this.user)
    this.userData = {
      firstName: this.user.first_name,
      lastName: this.user.last_name,
      email: this.user.email,
      country: this.user.country,
      zipcode: "",
      phone: this.user.phone,
      city: "",
      addressLine1: ""
    }
    this.getCourseDetails();
  },
  methods: {
    handleFormSubmission(formData) {
      this.step = 3;
      console.log("Checkout Data:", formData);
      // Proceed with order processing
    },
    async getCourseDetails() {
      try {
        const response = await axios.get("courses/view/"+this.$route.params.id);
        this.course = response.data.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style scoped>
.checkout-page {
  text-align: center;
  font-family: 'Gothic';
}
.checkout-page h1 {
  padding: 2rem 0;
  background-color: #0e1332;
  color: #fff;
  font-family: 'GothicB';
}
.order-summary {
  margin: 2rem auto;
  max-width: 60rem;
  overflow: hidden;
  padding: 0 1.5rem;
}
.container {
  margin: 2rem auto;
  max-width: 60rem;
  padding: 0 1.5rem;
}
.container h2 {
    text-align: left;
    font-family: 'GothicB';
}
.order-summary table {
  width: 100%;
  border: 1px solid #ccc;
  border-collapse: collapse;
}
.order-summary th,
.order-summary td {
  padding: 1rem;
  text-align: left;
  width: 50%;
  border: 1px solid #ccc;
}
.order-summary th {
  font-weight: 800;
  font-family: 'GothicB';
}

.note {
  color: red;
  margin: 2rem 0;
  text-align: left;
}
</style>
